import { render } from "./SteamDeckSale.vue?vue&type=template&id=3b953e84&scoped=true"
import script from "./SteamDeckSale.vue?vue&type=script&lang=js"
export * from "./SteamDeckSale.vue?vue&type=script&lang=js"

import "./SteamDeckSale.vue?vue&type=style&index=0&id=3b953e84&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b953e84"]])

export default __exports__